// extracted by mini-css-extract-plugin
export default {"mealEditInfo":"o8gibf3YFdbT8t8OclEw"};